import { Reducer } from "redux";

import { UpdateDisciplineLevelNote } from "../models/Api/Notes";
import { UpdateDisciplineLevelNotesDispatchTypes } from "../models/DispatchTypes/Notes";
import { UpdateDisciplineLevelNotesActionDispatchTypes } from "../constants/Notes";

export const initialState: UpdateDisciplineLevelNote = {
  loading: false,
  response: {
    disciplineNoteId: -1,
    serviceRequestDisciplineId: -1,
    noteEntryId: -1,
    dateCreated: "",
    dateUpdated: "",
    userCreated: "",
    fullNameCreated: "",
    noteTemplateId: -1,
    templateName: "",
    noteEntryJson: "",
    comment: "",
    highestCred: null,
  },
};

const UpdateDisciplineLevelNotesReducer: Reducer<
  UpdateDisciplineLevelNote,
  UpdateDisciplineLevelNotesDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case UpdateDisciplineLevelNotesActionDispatchTypes.UPDATE_DISCIPLINE_NOTES_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case UpdateDisciplineLevelNotesActionDispatchTypes.UPDATE_DISCIPLINE_NOTES_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case UpdateDisciplineLevelNotesActionDispatchTypes.UPDATE_DISCIPLINE_NOTES_RESET: {
      return initialState;
    }
  }
  return state;
};

export default UpdateDisciplineLevelNotesReducer;
